import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { API } from "../api";

export const eventQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ["event", id],
    queryFn: async () => {
      const response = await API.v2.eventsV2ControllerFindOne(id);
      return response.data;
    },
    enabled: !!id,
  });

export const useEvent = (id: string) => {
  return useQuery(eventQueryOptions(id));
};

export const useEventSuspense = (id: string) => {
  return useSuspenseQuery(eventQueryOptions(id));
};
